/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { Switch, Route, useLocation } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { PrivateRoutes } from './PrivateRoutes'
import { AuthPage } from '../modules/auth'
import { ErrorsPage } from '../modules/errors/ErrorsPage'
import { useAuth } from '../contexts/AuthProvider'
import './app.css'

const Routes: FC = () => {
  const { isAuthorized, loading } = useAuth();
  const location = useLocation();

  React.useEffect(() => {
    const body = document.querySelector('body');

    if (location?.pathname === '/login') {
      body?.classList.add('without-scroll');
    }
    else {
      body?.classList.remove('without-scroll');
    }
  }, [location]);

  return (
    <Switch>
      <Route path='/error' component={ErrorsPage} />
      {!loading && (
        !isAuthorized ? (
          <Route>
            <AuthPage />
          </Route>
        ) : (
          <>
            <MasterLayout>
              <PrivateRoutes />
            </MasterLayout>
          </>
        )
      )}
    </Switch>
  )
}

export { Routes }
